import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { IconType } from 'react-icons';

import { StyledIcon, StyledSidebarButton, StyledSidebarLabel } from './styled';

const SidebarButton: FC<{ text: string; url: string; src: IconType; onNavigate?: () => void }> = ({
  text,
  url,
  src: Icon,
  onNavigate,
}) => {
  const pathMatch = `/admin/${url}`;
  const isActive = window.location.href.indexOf(pathMatch) > -1;

  return (
    <Link to={pathMatch} onClick={onNavigate}>
      <StyledSidebarButton type="button" $isActive={isActive}>
        <StyledIcon>
          <Icon size={30} />
        </StyledIcon>
        <StyledSidebarLabel title={text}>{text}</StyledSidebarLabel>
      </StyledSidebarButton>
    </Link>
  );
};

export default SidebarButton;
